import * as z from 'zod';

export const recordingBookmarkSchema = z.object({
  bookmark: z
    .string()
    .trim()
    .min(1, 'Bookmark is required')
    .max(255, 'Bookmark must be less than 255 characters'),
});
